import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import portfolio1 from "@/assets/portfolio/chehalis-1.jpg";
import portfolio2 from "@/assets/portfolio/gigharbor-4.jpg";
import portfolio3 from "@/assets/portfolio/chehalis-2.jpg";
import portfolio4 from "@/assets/portfolio/gigharbor-5.jpg";
import portfolio5 from "@/assets/portfolio/chehalis-4.jpg";
import portfolio6 from "@/assets/portfolio/gigharbor-7.jpg";

const portfolioItems = [
  { image: portfolio1, category: "Aerial / Twilight", location: "Chehalis, WA" },
  { image: portfolio2, category: "Interior", location: "Gig Harbor, WA" },
  { image: portfolio3, category: "Waterfront", location: "Chehalis, WA" },
  { image: portfolio4, category: "Interior", location: "Gig Harbor, WA" },
  { image: portfolio5, category: "Exterior", location: "Chehalis, WA" },
  { image: portfolio6, category: "Interior", location: "Gig Harbor, WA" },
];

const PortfolioSection = () => {
  return (
    <section className="py-24 bg-secondary">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-primary font-medium tracking-[0.2em] uppercase text-sm mb-4">
            Our Work
          </p>
          <h2 className="font-serif text-3xl md:text-5xl font-semibold text-foreground mb-6">
            Featured Properties
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Browse our portfolio of stunning real estate photography and videography 
            from properties across Washington and Arkansas.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-12">
          {portfolioItems.map((item, index) => (
            <div
              key={index}
              className={`group relative overflow-hidden rounded-lg cursor-pointer ${
                index === 0 ? "col-span-2 row-span-2" : ""
              }`}
            >
              <div className={`${index === 0 ? "aspect-square" : "aspect-[4/3]"} overflow-hidden`}>
                <img
                  src={item.image}
                  alt={`${item.category} photography in ${item.location}`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-background/0 group-hover:bg-background/60 transition-colors duration-300" />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="text-center">
                  <p className="text-primary text-sm font-medium tracking-wide uppercase">
                    {item.category}
                  </p>
                  <p className="text-foreground font-serif text-xl">
                    {item.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button variant="outline" size="lg" asChild>
            <Link to="/portfolio">
              View Full Portfolio
              <ArrowRight className="ml-2" size={18} />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
